import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState, useRef } from 'react';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import moment from 'moment-timezone';

import swal from 'sweetalert';
import Select from 'react-select';
import { Modal, IconButton, Box, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import './workplan.css'


const SERVER_URL = process.env.REACT_APP_API_URL;


function CreateWorkPlan() {

    const [setLoad, setLoading] = useState(false)
    const [planDetails, setPlanDetails] = useState([{ date: '', day: '', plan: '' }]);
    const [selectedWeek, setSelectedWeek] = useState({ start: '', end: '' });
    const [plan, setPlan] = useState({ date: '' });
    const [selectedDays, setSelectedDays] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedDayIndex, setSelectedDayIndex] = useState(null);
    const location = useLocation();
    const [searchISLoading, setSearchIsLoading] = useState(false)
    const [groupedOptions, setGroupedOptions] = useState([
        {
            label: 'Stores',
            options: [],
        },
    ]);

    const { selectedPIDData } = location.state || {};
    const [isSubmitting, setIsSubmitting] = useState('auto');
    const [weekDays, setWeekDays] = useState([]);
    const [selectedStores, setSelectedStores] = useState({});
    const [activityNotes, setActivityNotes] = useState({});

    const [storeOptions, setStoreOptions] = useState([]);

    const handleTextChange = (value, index) => {
        const updatedActivityNotes = { ...activityNotes, [index]: value };
        setActivityNotes(updatedActivityNotes);

    };

    const handleSelectChange = (selectedOptions, index) => {
        const stores = selectedOptions.map(option => option.value);
        const updatedSelectedStores = { ...selectedStores, [index]: stores };
        setSelectedStores(updatedSelectedStores);
    };

    const resetForm = () => {

        const formRef = useRef(null);

        setSelectedWeek({ start: '', end: '' });
        setWeekDays([]);
        setSelectedStores([]);
        setActivityNotes([]);

        if (formRef.current) {
            formRef.current.reset();
        }
    };


    const [formData, setFormData] = useState({
        retailer_code: "",
        store_name: "",
        email: "",
        abn: "",
        state: "",
        city: "",
        postcode: "",
        street_name: "",
    });


    const handleSubmit = async (e) => {

        e.preventDefault();
        setSearchIsLoading(true)
        setIsSubmitting('unset');
        if (!selectedWeek) {
            //toast.error("Please select a week before submitting.");
            swal({
                title: "Error",
                text: 'Please select a week before submitting.',
                icon: "error",
                button: "Close",
            });
            setSearchIsLoading(false);
            return;
        }

        if (
            formData.retailer_code === "" &&
            formData.store_name === "" &&
            formData.email === "" &&
            formData.abn === "" &&
            formData.state === "" &&
            formData.city === "" &&
            formData.postcode === "" &&
            formData.street_name === ""
        ) {
            toast.error("At least one input field must be filled");
            setSearchIsLoading(false)
            setIsSubmitting('auto');
            return;
        } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter  post code or city name");
            setSearchIsLoading(false)
            setIsSubmitting('auto');
            return;
        } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter street name or post code");
            setSearchIsLoading(false)
            setIsSubmitting('auto');
            return;
        }

        const headers = await getApiHeader();
        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([key, value]) => value !== "")
        );
        try {
            const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
                headers: headers
            });

            const options = response.data.data.map((value) => ({
                label: value.retailer_company_name,
                // value: value.retailer_code,
                value: value.retailer_id,

            }));

            const updatedStoreOptions = weekDays.map((day, index) => {
                return {
                    ...day,
                    options: options,
                };
            });

            setStoreOptions(updatedStoreOptions);

            setModalOpen(false)
            setSearchIsLoading(false)
            setIsSubmitting('auto');
            //   setLoading(false);
            if (options.length === 0) {
                swal({
                    title: "Error",
                    text: 'No shop details found.',
                    icon: "error",
                    button: "Close",
                });
            } else {
                swal({
                    title: "Success",
                    text: 'Shop details found.',
                    icon: "success",
                    button: "Close",
                });
            }


        } catch (error) {
            console.log("error---------->", error);

            // Displaying the error in a modal if the request fails
            let errorMessage = "An unexpected error occurred.";

            if (error.response) {
                // If the error response contains a message from the API
                errorMessage = error.response.data?.message || error.response.data?.error || "An error occurred during the request.";
            } else if (error.request) {
                // If the error has no response (network issues, no internet, etc.)
                errorMessage = "Network error. Please check your internet connection.";
            }

            // Show the error message in a modal
            swal({
                title: "API Error",
                text: errorMessage,
                icon: "error",
                button: "Close",
            });

            setModalOpen(false);
            setSearchIsLoading(false);
            setIsSubmitting('auto');
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const getWeekOptions = () => {
        const options = [];

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const currentDate = moment.tz(timezone);


        const currentDay = currentDate.day();

        const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;

        currentDate.add(daysUntilMonday, 'days');

        for (let i = 0; i < 4; i++) {

            const startOfWeek = currentDate.clone().add(i * 7, 'days').toDate();
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 4);

            const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;

            const weekRange = {
                start: startOfWeek.toISOString().split('T')[0],
                end: endOfWeek.toISOString().split('T')[0]
            };

            options.push(
                <option key={i} value={JSON.stringify(weekRange)}>
                    {weekLabel}
                </option>
            );
            
        }

        return options;
    };



    const handleWeekChange = (e) => {
        const selectedValue = e.target.value;

        if (!selectedValue) {
            setSelectedWeek(null);
            setWeekDays([]);
            return;
        }

        try {

            const weekRange = JSON.parse(selectedValue);

            const startDate = new Date(weekRange.start);
            const dayOfWeek = startDate.getDay();

            if (dayOfWeek === 0) {

                startDate.setDate(startDate.getDate() + 1);
                weekRange.start = startDate.toISOString().split('T')[0];

                const endDate = new Date(weekRange.end);
                endDate.setDate(endDate.getDate() + 1);

                weekRange.end = endDate.toISOString().split('T')[0];
            }
            else { // For other days (normal case)
                weekRange.start = startDate.toISOString().split('T')[0]; // Keep start date as it is
                const endDate = new Date(weekRange.end);
                weekRange.end = endDate.toISOString().split('T')[0]; // Keep end date as it is
            }

            setSelectedWeek(weekRange);

            setPlan(prev => ({ ...prev, date: weekRange.start }));

            const days = [];
            for (let i = 0; i < 5; i++) {
                const day = new Date(startDate);
                day.setDate(startDate.getDate() + i);
                days.push({
                    date: day.toISOString().split('T')[0],
                    dayName: day.toLocaleString('default', { weekday: 'long' })
                });
            }

            setWeekDays(days);

        } catch (error) {
            // Catch any JSON parsing errors
            console.error("Failed to parse selected value:", error);
        }
    };


    const handleModalToggle = (index) => {
        setSelectedDayIndex(index);
        setModalOpen(!isModalOpen);
    };

    const handleWorkSubmit = async (e) => {
        e.preventDefault();

        swal({
            title: 'Are you sure?',
            text: `Do you want to Create the work plan?`,
            icon: 'warning',
            buttons: {
                confirm: {
                    text: 'Yes, submit it',
                    className: 'btn-confirm',
                },
                cancel: {
                    text: 'No, cancel',
                    visible: true,
                    className: 'btn-cancel',
                },
            },
            iconColor: '#e31579', // Optionally change the icon color
        }).then(async (isConfirmed) => {
            if (!isConfirmed) {
                // If the user cancels, stop the loading indicator
                setLoading(false);
                return;
            }
            setLoading(true);
            const safeWeekDays = weekDays || [];
            const safeSelectedStores = selectedStores || [];
            const safeActivityNotes = activityNotes || [];

            // Prepare the payload
            const payload = {
                work_week_start_date: selectedWeek.start,
                work_week_end_date: selectedWeek.end,

                week_plan_data: safeWeekDays.map((day, index) => ({
                    date: day.date,
                    stores: (Array.isArray(safeSelectedStores[index]) ? safeSelectedStores[index] : []).map(store => store.toString()) || [],  // Safely map or fallback to empty array
                    activity_notes: safeActivityNotes[index] || '', // Activity notes
                }))
            };

            // Check if any day has stores or activity notes
            const hasValidData = payload.week_plan_data.some(day =>
                day.stores.length > 0 || day.activity_notes.trim() !== ''
            );

            const headers = await getApiHeader();

            try {
                // Send the payload to the API
                const response = await axios.post(`${SERVER_URL}work-plan/create-work-plan`, payload, {
                    headers: headers
                });

                if (response.status === 200) {
                    const successMessage = response.data?.message;
                    swal({
                        title: "Success",
                        text: successMessage,
                        icon: "success",
                        button: "Close",
                    }).then(() => {
                        window.location.reload();
                    });
                    setLoading(false);
                } else {
                    // In case status is not 200, fallback to a generic error message
                    const errorMessage = rerror?.response?.data?.message || 'There was an issue with the submission.';
                    swal({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        button: "Close",
                    });
                    setLoading(false);
                }

                setTimeout(() => {
                    window.location.reload(); // Reload the page after 3 seconds
                }, 3000);
                setLoading(false);
            } catch (error) {
                console.error('API call error:', error);
                const errorMessage = error?.response?.data?.message || "Error submitting work plan. Please try again.";
                swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    button: "Close",
                });
                setLoading(false);

            }
        });
    };

    useEffect(() => {
        if (location.state) {
            const weekValue = {
                start: "2024-10-28",
                end: "2024-11-01"
            };

            handleWeekChange({ target: { value: JSON.stringify(weekValue) } });
        } else {
            console.log('No selected PID Data available.');
        }
    }, []);
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="container">
                {setLoad ? (
                    <Backdrop
                        open={true}
                        style={{
                            color: '#fff',
                            zIndex: 9999,
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>


                ) : (
                    <form className="workplanform col-lg-12" onSubmit={handleWorkSubmit}>
                        {location.state ? (
                            <h4>{location.state.reviewer.name} Work Details</h4>

                        ) : (
                            <>

                                <h4>Create Work Plan</h4>
                                <label htmlFor="work-week" className="label">Select the Week:  </label>
                                <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} >
                                    <option value="">Please choose an option</option>
                                    {getWeekOptions()}
                                </select></>
                        )}

                        {weekDays?.length > 0 && (
                            <>
                                <div className="row align-items-center mb-3">
                                    <label htmlFor="plan-details" className="label col-12">
                                        {location.state
                                            ? "Edit Work Plan Details:"
                                            : "Add Work Plan Details:"}

                                    </label>
                                    {weekDays.map((day, index) => (
                                        <div className="row mb-4" key={index}>
                                            <div className="col-md-3">
                                                <input
                                                    className="form-control p-3"
                                                    value={`${day.date} - ${day.dayName}`}
                                                    readOnly
                                                    style={{
                                                        // borderColor: '#e20e75',
                                                        borderRadius: '5px',
                                                        padding: '5px'
                                                    }}
                                                    aria-label={`${day.dayName} date`}
                                                />
                                                <input
                                                    type="hidden"
                                                    name="work_plan"
                                                    value={day.date || ''}
                                                />

                                            </div>

                                            <div className="col-md-8">
                                                <Select
                                                    isMulti
                                                    options={storeOptions[index]?.options || []}
                                                    value={day.selectedDays}
                                                    onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                                    placeholder="Search and add stores for revisits."
                                                    className="basic-multi-select  "
                                                    classNamePrefix="select"
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            borderRadius: '5px',
                                                            padding: '5px',
                                                        }),
                                                        multiValue: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: '#c11d6c',
                                                            color: 'white',
                                                            padding: '1px',
                                                        }),
                                                        multiValueLabel: (provided) => ({
                                                            ...provided,
                                                            color: 'white',
                                                        }),
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-1">
                                                <Tooltip title="Search details of stores" placement="bottom-end">
                                                    <IconButton
                                                        onClick={() => handleModalToggle(index)}
                                                        aria-label="search"
                                                        style={{
                                                            marginLeft: '10px',
                                                            transition: 'transform 0.2s',
                                                        }}
                                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                    >
                                                        <SearchIcon
                                                            sx={{
                                                                color: '#e20e75',
                                                                transition: 'transform 0.2s, color 0.2s',
                                                                '&:hover': {
                                                                    transform: 'scale(1.2)',
                                                                    color: '#d50b66',
                                                                },
                                                            }}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <br></br>

                                            <div className="col-md-12 mt-3">
                                                <ReactQuill
                                                    //value={day.plan || ''}
                                                    onChange={(value) => handleTextChange(value, index)}
                                                    placeholder="Please provide your planned activities, such as details of new shop visits, shop revisits, and any other relevant tasks."
                                                    modules={{
                                                        toolbar: [
                                                            [{ 'header': [1, 2, false] }],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                            ['link'],
                                                            ['clean']
                                                        ]
                                                    }}
                                                    style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {location.state && (
                                    <>
                                        <label htmlFor="plan-details" className="label col-12">Reporting Manager Comments  </label>
                                        <div className="col-md-12 mt-3">
                                            <ReactQuill
                                                // value={day.plan || ''}
                                                onChange={(value) => handleTextChange(value, index)}
                                                placeholder="Provide your planned activities."
                                                modules={{
                                                    toolbar: [
                                                        [{ 'header': [1, 2, false] }],
                                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                        ['link'],
                                                        ['clean']
                                                    ]
                                                }}
                                                style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                                            />
                                        </div> </>)}


                                {location.state ? (
                                    <>
                                        <div className="text-end">
                                            <button type="button" className="btn btn-success col-lg-4">Approve</button>
                                            <button type="button" className="btn btn-danger ms-2 col-lg-4">Reject</button>
                                        </div>
                                    </>
                                ) : (
                                    <button type="submit" className="submit-button">Submit</button>
                                )}                       </>
                        )}
                        <br></br>
                    </form>
                )}
            </div>


            <Modal open={isModalOpen} onClose={handleModalToggle}>

            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    outline: 'none',
                    borderRadius: 2,
                   
                    maxHeight: '80%',   // Adding a max height to limit the box size
                    '@media (max-width: 950px)': {
                        maxHeight: '80%', // Adjust height on medium screens
                        overflow: isSubmitting, // Conditional overflow
                    },
                    '@media (max-width: 740px)': {
                        maxHeight: '80%', // Adjust height on small screens
                        overflow: isSubmitting, // Conditional overflow
                    },
                    '@media (max-width: 480px)': {
                        width: '350px', 
                        maxHeight: '90%',  
                        overflow: isSubmitting, // Conditional overflow
                    },
                    '@media (max-width: 428px)': {
                        width: '350px', 
                        maxHeight: '90%',  
                        overflow: isSubmitting, // Conditional overflow
                    }
                }}
>

                    {!searchISLoading && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'transparent',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: 'black',
                            }}
                            onClick={handleModalToggle} // This will close the modal
                        >
                            &times; {/* This is the "×" symbol */}
                        </button>
                    )}

                    {searchISLoading ? (
                        <Backdrop
                            open={true}
                            style={{
                                color: '#fff',
                                zIndex: 9999,
                            }}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>


                    ) : (
                        <form className="modalstore" action="" method="" onSubmit={handleSubmit}  autoComplete="off">
                            <div className="formbold-mb-5 formbold-pt-3" style={{ marginLeft: "10px", marginRight: "10px" }}>
                                <label className="formbold-form-label formbold-form-label-2">
                                </label>
                                <div className="flex flex-wrap formbold--mx-3">
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Store Name
                                        </label>
                                        <div className="formbold-mb-5">
                                            <input
                                                type="text"
                                                name="store_name"
                                                id="store_name"
                                                placeholder="Enter Store Name"
                                                className="form-control"
                                                value={formData.store_name}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Email  Address
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                placeholder="Enter Email Address"
                                                className="form-control"
                                                value={formData.email}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Retailer ID
                                            </label>
                                            <input
                                                type="text"
                                                name="retailer_code"
                                                id="retailer_code"
                                                placeholder="Enter Retailer ID"
                                                className="form-control"
                                                value={formData.retailer_code}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                ABN
                                            </label>
                                            <input
                                                type="text"
                                                name="abn"
                                                id="abn"
                                                placeholder="Enter ABN"
                                                className="form-control"
                                                value={formData.abn}
                                                onChange={handleChange}
                                                maxLength={12}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                City
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                placeholder="Enter City Name"
                                                className="form-control"
                                                value={formData.city}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Post Code
                                            </label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                id="postcode"
                                                placeholder="Enter Post Code"
                                                className="form-control"
                                                value={formData.postcode}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Street Name
                                            </label>
                                            <input
                                                type="text"
                                                name="street_name"
                                                id="street_name"
                                                placeholder="Enter Street Name"
                                                className="form-control"
                                                value={formData.street_name}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            State
                                        </label>
                                        <select
                                            className="form-control"
                                            name="state"
                                            id="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>
                                            <option value="Act">ACT</option>
                                            <option value="NSW">NSW</option>
                                            <option value="NIT">NIT</option>
                                            <option value="QLD">QLD</option>
                                            <option value="SA">SA</option>
                                            <option value="TAS">TAS</option>
                                            <option value="VIC">VIC</option>
                                            <option value="WA">WA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="search-store-buttons">
                                <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

                            </div>
                        </form>
                    )}
                </Box>
            </Modal>
        </DashboardLayout>
    );
}

export default CreateWorkPlan;
